import { Component, computed, DestroyRef, inject } from '@angular/core';
import { TemplateDocumentService } from '../../services/template-document.service';
import { DynamicRouteHandlingService, rxResourceFixed } from '@zayan-erp/shared';
import { DocPreviewComponent } from '../../../../../shared/src/lib/components/doc-preview/doc-preview.component';
import { map, of } from 'rxjs';
import { FilesUtility } from '../../utils/files-utility';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'lib-template-preview',
  imports: [DocPreviewComponent, TitleCasePipe],
  templateUrl: './template-preview.component.html',
  styleUrl: './template-preview.component.scss',
  standalone: true
})
export class TemplatePreviewComponent {
  #templateService = inject(TemplateDocumentService);
  #activatedRoute = inject(ActivatedRoute);
  #filesUtility = inject(FilesUtility);
  #toastr = inject(ToastrService);
  #dynamicRouteHandling = inject(DynamicRouteHandlingService);
  #destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.#dynamicRouteHandling.submitButton$
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(() => this.downloadDocument());
  }

  templateId = toSignal<string | null>(
    this.#activatedRoute.paramMap.pipe(map((paramMap: ParamMap) => paramMap.get('templateId'))),
    {
      initialValue: null
    }
  );

  templateRxResource = rxResourceFixed({
    params: () => ({ id: this.templateId() }),
    defaultValue: null,
    stream: ({ params }) => {
      if (!params.id) {
        return of(null);
      }
      return this.#templateService.readTemplateDocument(params.id);
    }
  });

  templateVariables = rxResourceFixed({
    params: () => ({ id: this.template()?.templateVariable?.id }),
    defaultValue: [],
    stream: ({ params }) => {
      if (!params?.id) {
        return of([]);
      }
      return this.#templateService.readTemplateVariables(params?.id);
    }
  });

  template = computed(() => this.templateRxResource.value());

  tempVariables = computed(() => {
    const value = this.templateVariables.value();
    return value ?? [];
  });

  downloadDocument() {
    let downloadUrl: string | null = null;
    let fileName = '';
    downloadUrl = this.template()?.s3Document?.directUrl ?? null;
    fileName = this.template()?.name + '.' + this.template()?.fileType;

    if (downloadUrl && fileName) {
      this.#filesUtility.downloadFileFromUrl(downloadUrl!, fileName);
    } else {
      this.#toastr.error('File download URL or name is not available');
    }
  }
}
